import {Restaurant} from "../Services/qdm.service";
import {RestaurantHistoryAbstract} from "./RestaurantHistoryManager";
import {CookieService} from "ngx-cookie-service";
import {compressToBase64, decompressFromBase64} from 'lz-string';

export class CookieHistoryImpl implements RestaurantHistoryAbstract {

  private readonly COOKIE_NAME = 'restaurantHistory';

  add(cookieService: CookieService, restaurant: Restaurant): void {
    let history = cookieService.get(this.COOKIE_NAME);
    history = decompressFromBase64(history);

    let historyArray: Restaurant[] = [];
    if (history) {
      historyArray = JSON.parse(history);
    }

    if (historyArray.find(rest => rest.id === restaurant.id)) {
      // move elem to top
      historyArray = historyArray.filter(rest => rest.id !== restaurant.id);
      historyArray.unshift(restaurant);
      cookieService.set(this.COOKIE_NAME, compressToBase64(JSON.stringify(historyArray)), 365, "/");
      return;
    }

    historyArray.unshift(restaurant);
    cookieService.set(this.COOKIE_NAME, compressToBase64(JSON.stringify(historyArray)), 365, "/");
  }

  getAll(cookieService: CookieService): Restaurant[] {
    return JSON.parse(decompressFromBase64(cookieService.get(this.COOKIE_NAME)) || '[]');
  }

  removeRestaurantById(cookieService: CookieService, id: number): Restaurant[] {
    const oldHistory = this.getAll(cookieService);
    const newHistory = oldHistory.filter((restaurant) => restaurant.id !== id);

    cookieService.set(this.COOKIE_NAME, compressToBase64(JSON.stringify(newHistory)), 365, "/");
    return newHistory;
  }

}
